import { Storage, Auth } from "aws-amplify";
import aws_config from "../../aws-exports.js";
import { ACCESS_TYPES } from "../constants/AppEnums.js";
import AWS from "aws-sdk";
import axios from "axios";
import { API } from "aws-amplify";
import {
  GET_SIGNED_URL_PATH,
  UPLLOAD_FILE_URL_PATH,
} from "../constants/ApiConstants.js";
import { callApigateway } from "../api/callApi.js";
const API_NAME = "PhotosAPI";

export function isUrlExpired(signedUrl) {
  try {
    const url = new URL(signedUrl);
    const expires = url.searchParams.get("Expires");

    if (!expires) {
      throw new Error("Expiration time not found in signedUrl");
    }

    const expirationDate = new Date(expires * 1000); // Convert Unix timestamp to JavaScript Date
    const now = new Date();

    return now >= expirationDate;
  } catch (error) {
    console.log("Error checking URL expiration:", error);
    return null;
  }
}

export async function getSignedUrl(action, recourse_type, resourceName, fileName) {
  const apiName = "CubexApiGateWay";

  if (!resourceName) throw new Error("Resource name is required");
  if (!recourse_type) throw new Error("Resource type is required");
  if (!action) throw new Error("Action is required");

  try {
    const user = await Auth.currentAuthenticatedUser();
    const user_id = user.attributes["custom:user_id"];

    // Build query string conditionally
    const queryParams = new URLSearchParams({ user_id });
    if (fileName) queryParams.append("file_name", fileName);

    const path = `/${action}/${recourse_type}/${resourceName}?${queryParams.toString()}`;

    const response = await callApigateway({
      endpoint: path,
      method: "GET",
      body: null
    });

    console.log(response);
    return response;
  } catch (error) {
    console.error("Error getting signed URL:", error);
    return null;
  }
}

export async function fetchS3FileContent(resource_type, file_name) {
  try {
    const url = await getSignedUrl(
      GET_SIGNED_URL_PATH,
      resource_type,
      file_name
    );
    if (!url) {
      throw new Error("Signed URL not found");
    }
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const content = await response.text();
    console.log("Result:", content);
    return content;
  } catch (error) {
    console.error("Error fetching file content", error);
    return null;
  }
}

// Set the region
AWS.config.update({ region: aws_config.aws_project_region }); // Replace with your bucket's region
function getObjectPrefix(access, fileName, orgId = "", userId = "") {
  let prefix = "";
  switch (access) {
    case ACCESS_TYPES.PUBLIC:
      prefix = "";
      break;
    case ACCESS_TYPES.PROTECTED:
      prefix = `${orgId}`;
      break;
    case ACCESS_TYPES.PRIVATE:
      prefix = `${userId}`;
      break;
    default:
      prefix = "";
  }
  if (prefix === "") return `${fileName}`;

  return `${prefix}/${fileName}`;
}

// function getBucketName(access) {
//   let bucketName;

//   switch (access) {
//     case ACCESS_TYPES.PUBLIC:
//       bucketName = aws_config.Storage.AWSPublicS3.bucket;
//       break;
//     case ACCESS_TYPES.PROTECTED:
//       bucketName = aws_config.Storage.AWSProtectedS3.bucket;
//       break;
//     case ACCESS_TYPES.PRIVATE:
//       bucketName = aws_config.Storage.AWSPrivateS3.bucket;
//       break;
//     default:
//       throw new Error("Invalid bucket type");
//   }

//   return bucketName;
// }

export async function uploadFileToS3(
  resource_type,
  fileName,
  fileContent,
  contentType,
  progressCallback,
  uploadCallback,
  errorCallback = null,
  cancelToken = null  
) {
  try {
    // Get the bucket name and region from the type
    const sined_url = await getSignedUrl(
      UPLLOAD_FILE_URL_PATH,
      resource_type,
      fileName
    );
    if (!sined_url) {
      throw new Error("Signed URL not found");
    }
    await axios
      .put(sined_url, fileContent, {
        headers: {
          "Content-Type": "", // set the content type header
        },
        onUploadProgress: (progressEvent) => {
          let progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (progressCallback) {
            progressCallback(progress);
          }
        },   
        cancelToken: cancelToken    
      })
      .then((res) => {
        console.log(res);
        if (uploadCallback) {
          uploadCallback(null);
        }        
      })
      .catch((err) => {
        console.log(err);
        if (axios.isCancel(err)) {
          console.log('Upload was cancelled');
        } else {
          errorCallback && errorCallback(err); // call the error callback if provided
        }
      });


    return null;
  } catch (error) {
    console.log("Error uploading file", error);
    errorCallback && errorCallback(error); // call the error callback if provided

  }
}
export async function removeS3File(bucketType, objectKey) {
  console.log("Not Implemented");
  // try {
  //   // Get the bucket name
  //   const bucketName = getBucketName(bucketType);

  //   // Get user attributes
  //   const user = await Auth.currentAuthenticatedUser();
  //   const userId = user.attributes.sub;
  //   const orgId = user.attributes["custom:primaryOrgId"];

  //   // Construct the S3 object key based on the type
  //   const objectKeyWithPrefix = getObjectPrefix(
  //     bucketType,
  //     objectKey,
  //     orgId,
  //     userId
  //   );

  //   // Get S3 instance
  //   const s3 = await getS3Instance();

  //   // Setup the parameters
  //   const params = {
  //     Bucket: bucketName,
  //     Key: objectKeyWithPrefix,
  //   };

  //   // Delete the file from S3
  //   const result = await s3.deleteObject(params).promise();

  //   console.log("File removed:", result);
  //   return true;
  // } catch (error) {
  //   console.log("Error removing file:", error);
  //   return false;
  // }
}
export async function removeS3Folder(bucketType, folderName) {
  console.log("Not Implemented");
}
